import { c as _c } from "react/compiler-runtime";
import WaveItem from "./WaveItem";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import CommonIntersectionElement from "@/components/utils/CommonIntersectionElement";
import { useWaves } from "@/hooks/useWaves";
export default function WavesListSearchResults(t0) {
  const $ = _c(30);
  const {
    identity,
    waveName
  } = t0;
  let t1;
  if ($[0] !== identity || $[1] !== waveName) {
    t1 = {
      identity,
      waveName
    };
    $[0] = identity;
    $[1] = waveName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    waves,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    status
  } = useWaves(t1);
  let t2;
  if ($[3] !== fetchNextPage || $[4] !== hasNextPage || $[5] !== isFetching || $[6] !== isFetchingNextPage || $[7] !== status) {
    t2 = state => {
      if (!state || status === "pending" || isFetching || isFetchingNextPage || !hasNextPage) {
        return;
      }
      fetchNextPage();
    };
    $[3] = fetchNextPage;
    $[4] = hasNextPage;
    $[5] = isFetching;
    $[6] = isFetchingNextPage;
    $[7] = status;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onBottomIntersection = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-tracking-tight tw-text-xl tw-font-medium tw-text-iron-50">Search</span>;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isFetching || $[11] !== waves.length) {
    t4 = waves.length === 0 && !isFetching && <p className="tw-mt-2 tw-block tw-mb-0 tw-text-sm tw-italic tw-text-iron-500">No results found. Please try a different keyword or create a new wave.</p>;
    $[10] = isFetching;
    $[11] = waves.length;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== waves) {
    t6 = waves.map(_temp);
    $[15] = waves;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <div className="tw-mt-3 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-4">{t6}</div>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isFetching) {
    t8 = isFetching && <div className="tw-w-full tw-text-center tw-mt-8"><CircleLoader size={CircleLoaderSize.XXLARGE} /></div>;
    $[19] = isFetching;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== onBottomIntersection) {
    t9 = <CommonIntersectionElement onIntersection={onBottomIntersection} />;
    $[21] = onBottomIntersection;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <div className="tw-overflow-hidden">{t7}{t8}{t9}</div>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t5) {
    t11 = <div>{t5}{t10}</div>;
    $[27] = t10;
    $[28] = t5;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function _temp(wave) {
  return <WaveItem key={`waves-${wave.id}`} wave={wave} />;
}